import { api } from './client'

const legalService = {
  /** AI-powered case law research chat with CourtListener tools */
  chat: async (text, history = []) => {
    const resp = await api.post('/legal-research/chat', { text, history })
    return resp.data
  },

  /** Direct case search (quick lookup without AI) */
  search: async (q, { court, filed_after, filed_before } = {}) => {
    const params = { q, court, filed_after, filed_before }
    const resp = await api.get('/legal-research/search', params)
    return resp.data
  },
}

export default legalService
